var $ad2bcec7a0192558$exports = {};
const $ad2bcec7a0192558$var$FPS = 30;
const $ad2bcec7a0192558$var$bound = (x, min, max)=>{
    return Math.max(min, Math.min(x, max));
};
const $ad2bcec7a0192558$var$initListeners = ()=>{
    document.addEventListener("gesturestart", function(e) {
        e.preventDefault();
        document.body.style.zoom = "0.99";
    });
    document.addEventListener("gesturechange", function(e) {
        e.preventDefault();
        document.body.style.zoom = "0.99";
    });
    document.addEventListener("gestureend", function(e) {
        e.preventDefault();
        document.body.style.zoom = "1";
    });
};
class $ad2bcec7a0192558$var$Canvas {
    constructor(){
        this.canvas = document.getElementById("canvas");
        this.ctx = this.canvas.getContext("2d");
        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;
        this.zoomLevel = 1;
        this.panX = 0;
        this.panY = 0;
        this.elements = [];
        this.isPanning = false;
        this.lastMouseX = 0;
        this.lastMouseY = 0;
        // Mouse events for panning
        this.canvas.addEventListener("mousedown", (e)=>{
            this.isPanning = true;
            this.lastMouseX = e.clientX;
            this.lastMouseY = e.clientY;
            this.canvas.style.cursor = "grabbing";
            e.preventDefault();
        });
        this.canvas.addEventListener("mousemove", (e)=>{
            if (this.isPanning) {
                const deltaX = e.clientX - this.lastMouseX;
                const deltaY = e.clientY - this.lastMouseY;
                // Convert pixel movement to world coordinates
                const baseUnitPx = 50;
                const scale = baseUnitPx * Math.pow(2, this.zoomLevel);
                this.panX += deltaX / scale;
                this.panY -= deltaY / scale; // Invert Y for proper coordinate system
                this.lastMouseX = e.clientX;
                this.lastMouseY = e.clientY;
                e.preventDefault();
            }
        });
        this.canvas.addEventListener("mouseup", (e)=>{
            this.isPanning = false;
            this.canvas.style.cursor = "grab";
            e.preventDefault();
        });
        this.canvas.addEventListener("mouseleave", (e)=>{
            this.isPanning = false;
            this.canvas.style.cursor = "grab";
        });
        // Touch events for mobile panning
        this.canvas.addEventListener("touchstart", (e)=>{
            if (e.touches.length === 1) {
                this.isPanning = true;
                this.lastMouseX = e.touches[0].clientX;
                this.lastMouseY = e.touches[0].clientY;
                e.preventDefault();
            }
        });
        this.canvas.addEventListener("touchmove", (e)=>{
            if (e.touches.length === 1 && this.isPanning) {
                const deltaX = e.touches[0].clientX - this.lastMouseX;
                const deltaY = e.touches[0].clientY - this.lastMouseY;
                // Convert pixel movement to world coordinates
                const baseUnitPx = 50;
                const scale = baseUnitPx * Math.pow(2, this.zoomLevel);
                this.panX += deltaX / scale;
                this.panY -= deltaY / scale; // Invert Y for proper coordinate system
                this.lastMouseX = e.touches[0].clientX;
                this.lastMouseY = e.touches[0].clientY;
                e.preventDefault();
            }
        });
        this.canvas.addEventListener("touchend", (e)=>{
            this.isPanning = false;
            e.preventDefault();
        });
        // Set initial cursor style
        this.canvas.style.cursor = "grab";
        document.addEventListener("wheel", (e)=>{
            this.zoom(e.deltaY, e.clientX, e.clientY);
            e.preventDefault();
        }, {
            passive: false
        });
        document.addEventListener("click", (e)=>{
            console.log(e);
        });
        setInterval(()=>{
            this.update();
        }, 1000 / $ad2bcec7a0192558$var$FPS);
    }
    zoom(level, mouseX, mouseY) {
        const oldZoomLevel = this.zoomLevel;
        this.zoomLevel -= level * 0.01; // Scale down zoom sensitivity (inverted direction)
        // If mouse position is provided, zoom towards that point
        if (mouseX !== undefined && mouseY !== undefined) {
            const baseUnitPx = 50;
            const oldScale = baseUnitPx * Math.pow(2, oldZoomLevel);
            const newScale = baseUnitPx * Math.pow(2, this.zoomLevel);
            // Convert mouse position to world coordinates before zoom
            const worldX = (mouseX - this.canvas.width / 2) / oldScale - this.panX;
            const worldY = -(mouseY - this.canvas.height / 2) / oldScale - this.panY;
            // Convert back to screen coordinates with new zoom
            const newScreenX = this.canvas.width / 2 + (worldX + this.panX) * newScale;
            const newScreenY = this.canvas.height / 2 - (worldY + this.panY) * newScale;
            // Adjust pan to keep the point under the mouse
            this.panX += (mouseX - newScreenX) / newScale;
            this.panY -= (mouseY - newScreenY) / newScale;
        }
    }
    clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    update() {
        this.clear();
        this.draw();
    }
    xyBounds() {
        return {
            xMin: -this.panX - this.canvas.width / 2 / this.getScale(),
            xMax: -this.panX + this.canvas.width / 2 / this.getScale(),
            yMin: -this.panY - this.canvas.height / 2 / this.getScale(),
            yMax: this.panY + this.canvas.height / 2 / this.getScale()
        };
    }
    drawAxis() {
        const ctx = this.ctx;
        const canvas = this.canvas;
        ctx.strokeStyle = "black";
        // Draw x-axis (horizontal line at y=0)
        const xAxisY = canvas.height / 2 - this.panY * this.getScale();
        if (xAxisY >= 0 && xAxisY <= canvas.height) {
            ctx.beginPath();
            ctx.moveTo(0, xAxisY);
            ctx.lineTo(canvas.width, xAxisY);
            ctx.stroke();
        }
        // Draw y-axis (vertical line at x=0)
        const yAxisX = canvas.width / 2 + this.panX * this.getScale();
        if (yAxisX >= 0 && yAxisX <= canvas.width) {
            ctx.beginPath();
            ctx.moveTo(yAxisX, 0);
            ctx.lineTo(yAxisX, canvas.height);
            ctx.stroke();
        }
        ctx.fillStyle = "black";
        ctx.font = "12px Arial";
        // Helper to find a "nice" tick step (1, 2, 5, 10, 20, 50, etc.)
        function niceStep(rawStep) {
            const exp = Math.floor(Math.log10(rawStep));
            const base = rawStep / Math.pow(10, exp);
            let niceBase;
            if (base < 1.5) niceBase = 1;
            else if (base < 3) niceBase = 2;
            else if (base < 7) niceBase = 5;
            else niceBase = 10;
            return niceBase * Math.pow(10, exp);
        }
        const scale = this.getScale();
        // Find a nice tick step in world units so that ticks are ~60-100px apart
        const minTickPx = 60;
        const tickStepWorld = niceStep(minTickPx / scale);
        // Find visible world bounds accounting for panning
        const xMin = -(canvas.width / 2) / scale - this.panX;
        const xMax = canvas.width / 2 / scale - this.panX;
        const yMin = -(canvas.height / 2) / scale - this.panY;
        const yMax = canvas.height / 2 / scale - this.panY;
        // Draw x axis ticks and labels
        ctx.textAlign = "center";
        ctx.textBaseline = "top";
        ctx.fillStyle = "black";
        ctx.font = "12px Arial";
        for(let x = Math.ceil(xMin / tickStepWorld) * tickStepWorld; x <= xMax; x += tickStepWorld)// Only label if x is an integer (no decimals)
        if (Math.abs(Math.round(x) - x) < 1e-8 && Math.abs(x) > 1e-8) {
            const px = canvas.width / 2 + (x + this.panX) * scale;
            ctx.beginPath();
            ctx.moveTo(px, xAxisY - 5);
            ctx.lineTo(px, xAxisY + 5);
            ctx.stroke();
            ctx.fillText(Math.round(x).toString(), px, xAxisY + 8);
        } else {
            // Still draw the tick, but don't label
            const px = canvas.width / 2 + (x + this.panX) * scale;
            ctx.beginPath();
            ctx.moveTo(px, xAxisY - 5);
            ctx.lineTo(px, xAxisY + 5);
            ctx.stroke();
        }
        // Draw y axis ticks and labels
        ctx.textAlign = "right";
        ctx.textBaseline = "middle";
        for(let y = Math.ceil(yMin / tickStepWorld) * tickStepWorld; y <= yMax; y += tickStepWorld)// Only label if y is an integer (no decimals)
        if (Math.abs(Math.round(y) - y) < 1e-8 && Math.abs(y) > 1e-8) {
            const py = canvas.height / 2 - (y + this.panY) * scale;
            ctx.beginPath();
            ctx.moveTo(yAxisX - 5, py);
            ctx.lineTo(yAxisX + 5, py);
            ctx.stroke();
            ctx.fillText(Math.round(y).toString(), yAxisX - 8, py);
        } else {
            // Still draw the tick, but don't label
            const py = canvas.height / 2 - (y + this.panY) * scale;
            ctx.beginPath();
            ctx.moveTo(yAxisX - 5, py);
            ctx.lineTo(yAxisX + 5, py);
            ctx.stroke();
        }
        // Draw origin label (only if origin is visible)
        if (xAxisY >= 0 && xAxisY <= canvas.height && yAxisX >= 0 && yAxisX <= canvas.width) {
            ctx.textAlign = "left";
            ctx.textBaseline = "top";
            ctx.fillText("0", yAxisX + 4, xAxisY + 4);
        }
    }
    getScale() {
        const baseUnitPx = 50;
        return baseUnitPx * Math.pow(2, this.zoomLevel);
    }
    gridToPixel(x, y) {
        const scale = this.getScale();
        return {
            x: this.canvas.width / 2 + (x + this.panX) * scale,
            y: this.canvas.height / 2 - (y + this.panY) * scale
        };
    }
    pixelToGrid(px, py) {
        const scale = this.getScale();
        return {
            x: (px - this.canvas.width / 2) / scale - this.panX,
            y: -(py - this.canvas.height / 2) / scale - this.panY
        };
    }
    getXAxisY() {
        return this.canvas.height / 2 - this.panY * this.getScale();
    }
    getYAxisY() {
        return this.canvas.width / 2 + this.panX * this.getScale();
    }
    addElement(element) {
        this.elements.push(element);
    }
    draw() {
        this.drawAxis();
        this.elements.forEach((element)=>element.draw());
    }
}
class $ad2bcec7a0192558$var$Stem {
    constructor(canvas, x, y, color){
        this.canvas = canvas;
        this.x = x;
        this.y = y;
        this.color = color;
    }
    draw() {
        const ctx = this.canvas.ctx;
        ctx.strokeStyle = this.color;
        ctx.lineWidth = 4;
        ctx.beginPath();
        const { x: px, y: py } = this.canvas.gridToPixel(this.x, this.y);
        // Draw the line (stem)
        ctx.moveTo(px, this.canvas.getXAxisY());
        ctx.lineTo(px, $ad2bcec7a0192558$var$bound(py, 0, this.canvas.canvas.height));
        ctx.stroke();
        // Draw the arc (circle) at the end of the line
        ctx.beginPath();
        ctx.arc(px, py, this.canvas.getScale() / 10, 0, 2 * Math.PI);
        ctx.fillStyle = this.color;
        ctx.fill();
        ctx.lineWidth = 1;
    }
}
class $ad2bcec7a0192558$var$GraphFunction {
    constructor(canvas, fn, color){
        this.canvas = canvas;
        this.fn = fn;
        this.color = color;
    }
    draw() {
        const ctx = this.canvas.ctx;
        ctx.strokeStyle = "blue";
        ctx.lineWidth = 4;
        ctx.beginPath();
        const { xMin: xMin, xMax: xMax, yMin: yMin, yMax: yMax } = this.canvas.xyBounds();
        const step = Math.floor((xMax - xMin) / 20);
        console.log(step);
        for(let x = 0; x <= xMax; x += 1){
            const stem = new $ad2bcec7a0192558$var$Stem(this.canvas, x, this.fn(x), this.color);
            stem.draw();
        }
        console.log(xMin);
        for(let x = 0; x >= xMin; x -= 1){
            const stem = new $ad2bcec7a0192558$var$Stem(this.canvas, x, this.fn(x), this.color);
            stem.draw();
        }
    }
}
// Convolution cache to avoid recomputing expensive integrals
class $ad2bcec7a0192558$var$ConvolutionCache {
    hashFunction(fn) {
        // Create a simple hash by sampling the function at several points
        const samples = [];
        for(let i = -10; i <= 10; i += 1)try {
            samples.push(fn(i));
        } catch  {
            samples.push(0);
        }
        return samples.join(",");
    }
    getCacheKey(fHash, gHash) {
        return `${fHash}|${gHash}`;
    }
    get(f, g, t) {
        const fHash = this.hashFunction(f);
        const gHash = this.hashFunction(g);
        const cacheKey = this.getCacheKey(fHash, gHash);
        // Check if functions have changed
        if (this.functionHashes.get(cacheKey) !== `${fHash}|${gHash}`) {
            this.cache.delete(cacheKey);
            this.functionHashes.set(cacheKey, `${fHash}|${gHash}`);
        }
        const functionCache = this.cache.get(cacheKey);
        if (functionCache) return functionCache.get(t) || null;
        return null;
    }
    set(f, g, t, value) {
        const fHash = this.hashFunction(f);
        const gHash = this.hashFunction(g);
        const cacheKey = this.getCacheKey(fHash, gHash);
        if (!this.cache.has(cacheKey)) this.cache.set(cacheKey, new Map());
        this.cache.get(cacheKey).set(t, value);
        this.functionHashes.set(cacheKey, `${fHash}|${gHash}`);
    }
    clear() {
        this.cache.clear();
        this.functionHashes.clear();
    }
    constructor(){
        this.cache = new Map();
        this.functionHashes = new Map();
    }
}
const $ad2bcec7a0192558$var$convolutionCache = new $ad2bcec7a0192558$var$ConvolutionCache();
const $ad2bcec7a0192558$var$util = {
    step: (n)=>{
        return n >= 0 ? 1 : 0;
    },
    impulse: (n, center = 0)=>{
        return Math.abs(n - center) < 0.1 ? 1 : 0;
    },
    rect: (n, width = 1, center = 0)=>{
        return Math.abs(n - center) <= width / 2 ? 1 : 0;
    },
    sinc: (n)=>{
        return n === 0 ? 1 : Math.sin(n) / n;
    },
    convolution: (f, g, t, bounds)=>{
        // Check cache first
        const cached = $ad2bcec7a0192558$var$convolutionCache.get(f, g, t);
        if (cached !== null) return cached;
        // Discrete convolution approximation
        let sum = 0;
        for(let x = Math.min(bounds.xMin, -10000); x <= Math.max(bounds.xMax, 10000); x += 1)sum += f(x) * g(t - x);
        // Cache the result
        $ad2bcec7a0192558$var$convolutionCache.set(f, g, t, sum);
        return sum;
    },
    createConvolution: (f, g, canvas)=>{
        return (x)=>{
            const bounds = canvas.xyBounds();
            return $ad2bcec7a0192558$var$util.convolution(f, g, x, bounds);
        };
    }
};
class $ad2bcec7a0192558$var$FunctionManager {
    constructor(canvas){
        this.functions = {
            f: null,
            g: null,
            h: null
        };
        this.graphElements = {
            f: null,
            g: null,
            h: null,
            convolution: null
        };
        this.colors = {
            f: "#0000ff",
            g: "#ff0000",
            h: "#800080",
            convolution: "green"
        };
        this.convolutionVisible = false;
        this.canvas = canvas;
        this.setupUI();
    }
    setupUI() {
        const fTextarea = document.getElementById("function-f");
        const gTextarea = document.getElementById("function-g");
        const hTextarea = document.getElementById("function-h");
        const plotButton = document.getElementById("plot");
        const toggleConfigButton = document.getElementById("toggle-config");
        const controlsDiv = document.getElementById("controls");
        const convolutionSelect = document.getElementById("convolution-select");
        const showConvolutionButton = document.getElementById("show-convolution");
        if (!fTextarea || !gTextarea || !hTextarea || !plotButton || !toggleConfigButton || !controlsDiv) {
            console.error("Required UI elements not found");
            return;
        }
        // Set default functions
        fTextarea.value = "x => u(x-2)";
        gTextarea.value = "x => Math.sin(x)";
        hTextarea.value = "x => Math.cos(x)";
        // Auto-plot the default functions
        this.plotFunctions();
        // Plot button handler
        plotButton.addEventListener("click", ()=>{
            this.plotFunctions();
        });
        // Config toggle handler
        toggleConfigButton.addEventListener("click", (e)=>{
            controlsDiv.classList.toggle("controls-hidden");
            if (controlsDiv.classList.contains("controls-hidden")) toggleConfigButton.textContent = "Show Config";
            else toggleConfigButton.textContent = "Hide Config";
        });
        // Show/hide checkboxes
        document.getElementById("show-f")?.addEventListener("change", ()=>this.updateVisibility());
        document.getElementById("show-g")?.addEventListener("change", ()=>this.updateVisibility());
        document.getElementById("show-h")?.addEventListener("change", ()=>this.updateVisibility());
        // Color pickers
        document.getElementById("color-f")?.addEventListener("change", (e)=>{
            this.colors.f = e.target.value;
            this.updateFunctionColors();
        });
        document.getElementById("color-g")?.addEventListener("change", (e)=>{
            this.colors.g = e.target.value;
            this.updateFunctionColors();
        });
        document.getElementById("color-h")?.addEventListener("change", (e)=>{
            this.colors.h = e.target.value;
            this.updateFunctionColors();
        });
        showConvolutionButton?.addEventListener("click", ()=>{
            this.toggleConvolution();
        });
        // Convolution selection
        convolutionSelect?.addEventListener("change", ()=>{
            if (this.convolutionVisible) this.updateConvolution();
        });
        // Enter key support for all textareas
        [
            fTextarea,
            gTextarea,
            hTextarea
        ].forEach((textarea)=>{
            textarea.addEventListener("keydown", (e)=>{
                if (e.key === "Enter" && e.ctrlKey) this.plotFunctions();
            });
        });
    }
    parseFunction(code) {
        try {
            // Create a function that takes x as parameter and includes utility functions
            if (code.length === 0) return null;
            const func = new Function("x", "u", "impulse", "rect", "Math", `return (${code})(x)`);
            // Test the function with a sample value
            const testValue = func(1, $ad2bcec7a0192558$var$util.step, $ad2bcec7a0192558$var$util.impulse, $ad2bcec7a0192558$var$util.rect, Math);
            if (typeof testValue !== "number" || !isFinite(testValue)) throw new Error("Function must return a finite number");
            // Return a wrapper function that provides the utility functions
            return (x)=>func(x, $ad2bcec7a0192558$var$util.step, $ad2bcec7a0192558$var$util.impulse, $ad2bcec7a0192558$var$util.rect, Math);
        } catch (error) {
            console.error("Error parsing function:", error);
            alert(`Error parsing function: ${error.message}`);
            return null;
        }
    }
    plotFunctions() {
        const fTextarea = document.getElementById("function-f");
        const gTextarea = document.getElementById("function-g");
        const hTextarea = document.getElementById("function-h");
        if (!fTextarea || !gTextarea || !hTextarea) return;
        // Parse functions
        const fFunc = this.parseFunction(fTextarea.value.trim());
        const gFunc = this.parseFunction(gTextarea.value.trim());
        const hFunc = this.parseFunction(hTextarea.value.trim());
        // Clear convolution cache when functions change
        $ad2bcec7a0192558$var$convolutionCache.clear();
        // Remove existing function elements
        this.clearFunctionElements();
        // Create new function elements
        this.functions.f = fFunc;
        this.functions.g = gFunc;
        this.functions.h = hFunc;
        this.graphElements.f = fFunc ? new $ad2bcec7a0192558$var$GraphFunction(this.canvas, fFunc, this.colors.f) : null;
        this.graphElements.g = gFunc ? new $ad2bcec7a0192558$var$GraphFunction(this.canvas, gFunc, this.colors.g) : null;
        this.graphElements.h = hFunc ? new $ad2bcec7a0192558$var$GraphFunction(this.canvas, hFunc, this.colors.h) : null;
        // Add to canvas based on visibility
        this.updateVisibility();
        console.log("Functions plotted successfully");
    }
    updateVisibility() {
        // Remove all function elements from canvas
        this.clearFunctionElements();
        // Add visible functions back
        const showF = document.getElementById("show-f")?.checked;
        const showG = document.getElementById("show-g")?.checked;
        const showH = document.getElementById("show-h")?.checked;
        if (showF && this.graphElements.f) this.canvas.addElement(this.graphElements.f);
        if (showG && this.graphElements.g) this.canvas.addElement(this.graphElements.g);
        if (showH && this.graphElements.h) this.canvas.addElement(this.graphElements.h);
        // Update convolution if it's shown
        this.updateConvolution();
    }
    toggleConvolution() {
        this.convolutionVisible = !this.convolutionVisible;
        this.updateConvolutionButton();
        this.updateConvolution();
    }
    updateConvolutionButton() {
        const button = document.getElementById("show-convolution");
        if (button) button.textContent = this.convolutionVisible ? "Hide Convolution" : "Show Convolution";
    }
    updateFunctionColors() {
        // Update existing graph elements with new colors
        if (this.graphElements.f) this.graphElements.f.color = this.colors.f;
        if (this.graphElements.g) this.graphElements.g.color = this.colors.g;
        if (this.graphElements.h) this.graphElements.h.color = this.colors.h;
    }
    updateConvolution() {
        // Remove existing convolution element
        if (this.graphElements.convolution) {
            const index = this.canvas.elements.indexOf(this.graphElements.convolution);
            if (index > -1) this.canvas.elements.splice(index, 1);
            this.graphElements.convolution = null;
        }
        if (!this.convolutionVisible) return;
        const convolutionSelect = document.getElementById("convolution-select");
        const selectedConvolution = convolutionSelect?.value;
        let func1 = null;
        let func2 = null;
        switch(selectedConvolution){
            case "f*g":
                func1 = this.functions.f;
                func2 = this.functions.g;
                break;
            case "f*h":
                func1 = this.functions.f;
                func2 = this.functions.h;
                break;
            case "g*h":
                func1 = this.functions.g;
                func2 = this.functions.h;
                break;
        }
        if (!func1 || !func2) {
            alert("Please plot the required functions first");
            return;
        }
        // Create convolution function
        const convolutionFunction = $ad2bcec7a0192558$var$util.createConvolution(func1, func2, this.canvas);
        this.graphElements.convolution = new $ad2bcec7a0192558$var$GraphFunction(this.canvas, convolutionFunction, this.colors.convolution);
        // Add to canvas
        this.canvas.addElement(this.graphElements.convolution);
        console.log(`Convolution ${selectedConvolution} plotted successfully`);
    }
    clearFunctionElements() {
        // Remove all function elements from canvas
        Object.values(this.graphElements).forEach((element)=>{
            if (element) {
                const index = this.canvas.elements.indexOf(element);
                if (index > -1) this.canvas.elements.splice(index, 1);
            }
        });
    }
}
const $ad2bcec7a0192558$var$init = ()=>{
    $ad2bcec7a0192558$var$initListeners();
    const canvas = new $ad2bcec7a0192558$var$Canvas();
    // Initialize function manager
    const functionManager = new $ad2bcec7a0192558$var$FunctionManager(canvas);
};
$ad2bcec7a0192558$var$init();


//# sourceMappingURL=path0.a4c58fbe.js.map
